import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useBriefingActionCount() {
  return useQuery({
    queryKey: ["briefing-action-count"],
    queryFn: async () => {
      const { count, error } = await supabase
        .from("briefing_actions")
        .select("id", { count: "exact", head: true })
        .eq("action_required", true)
        .eq("resolved", false);

      if (error) throw error;
      return count ?? 0;
    },
    refetchInterval: 30_000,
  });
}
